import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { isTestEnv } from "@faire/web--source/common/user-agent/isTestEnv";
import { getGlobalLookup } from "./lookup";
import { getAllOverriddenGlobalProperties } from "./override";
export function getGlobalProperty(name, defaultValue) {
  var _getGlobalLookup;
  var allOverriddenPageData = getAllOverriddenGlobalProperties();
  // Check if direct reference is mocked out
  if (name in allOverriddenPageData) {
    var overrideValue = allOverriddenPageData[name];
    if (!isTestEnv()) {
      // eslint-disable-next-line no-console
      console.log("Using global property override for ".concat(name, " of ").concat(JSON.stringify(overrideValue)));
    }
    return overrideValue !== null && overrideValue !== void 0 ? overrideValue : defaultValue;
  }
  var overrideProperties = {};
  var allOverriddenPageDataKeys = Object.keys(allOverriddenPageData);
  for (var _i = 0, _allOverriddenPageDat = allOverriddenPageDataKeys; _i < _allOverriddenPageDat.length; _i++) {
    var key = _allOverriddenPageDat[_i];
    var _key$split = key.split("."),
      _key$split2 = _slicedToArray(_key$split, 2),
      parent = _key$split2[0],
      child = _key$split2[1];
    // Check if child reference is mocked out
    if (name === parent && child !== undefined) {
      var _overrideValue = allOverriddenPageData[key];
      if (!isTestEnv()) {
        // eslint-disable-next-line no-console
        console.log("Using global property override for ".concat(key, " of ").concat(JSON.stringify(_overrideValue)));
      }
      overrideProperties[child] = _overrideValue;
    }
  }
  var value = (_getGlobalLookup = getGlobalLookup()(name)) !== null && _getGlobalLookup !== void 0 ? _getGlobalLookup : defaultValue;
  if (typeof process !== "undefined" && process.env.NEXT_PUBLIC_DEBUG_GLOBAL_LOOKUP && !globalsToSkip.includes(name)) {
    var _Error$stack;
    // eslint-disable-next-line no-console
    console.log("Global Lookup: ".concat(name), (_Error$stack = new Error().stack) === null || _Error$stack === void 0 ? void 0 : _Error$stack.split("\n").slice(1, 6));
  }
  if (_typeof(value) === "object" && Object.keys(overrideProperties).length !== 0) {
    return _objectSpread(_objectSpread({}, value), overrideProperties);
  }
  return value;
}
// Globals that we don't want to log - they are either expected (like window)
// or are too noisy to give any insight.
var globalsToSkip = ["window", "document", "location", "navigator", "needsHydration", "envName", "faire.app", "isRobot", "isPrerender", "settingsValues", "user", "retailer"];